export function createSymbolsTagsPlugin(): any {
    let plugin: any = {
        name: 'symbolsTags',
        title: 'Symbols/Tags',
        display: 'submenu',
        innerHTML: `<div className='header-button'>Symbols/Tags</div>`,
        buttonClass: 'header-button-wrapper',
        add: function (core: any, targetElement: any) {
            const context = core.context;
            context.symbolsTags = {
                targetButton: targetElement,
            };

            /** set submenu */
            let listDiv = this.setSubmenu(core);

            /** add event listeners */
            listDiv.querySelector('.se-list-inner').addEventListener('click', this.pickup.bind(core));

            /** append target button menu */
            core.initMenuTarget(this.name, targetElement, listDiv);
        },
        setSubmenu: function (core: any) {
            const listDiv = core.util.createElement('div');
            listDiv.className = 'se-submenu se-list-layer';

            let list = '<div class="se-list-inner">' +
                '<ul class="se-list-basic">' +
                '<li><button type="button" class="se-btn-list" data-command="section" title="Section">§ Section</button></li>' +
                '<li><button type="button" class="se-btn-list" data-command="trademark" title="Trademark">™ Trademark</button></li>' +
                '<li><button type="button" class="se-btn-list" data-command="copyright" title="Copyright">© Copyright</button></li>' +
                '<li><button type="button" class="se-btn-list" data-command="provisionLabel" title="Provision Label">🏷️ Provision Label</button></li>' +
                '<li><button type="button" class="se-btn-list" data-command="blankLeader" title="Blank Leader">→ Blank Leader</button></li>' +
                '<li><button type="button" class="se-btn-list" data-command="blankLeaderV2" title="Blank Leader Left Align">↦ Blank Leader Left Align</button></li>' +
                '<li><button type="button" class="se-btn-list" data-command="dotLeader" title="Dot Leader">… Dot Leader</button></li>' +
                '<li><button type="button" class="se-btn-list" data-command="ballotBox" title="Ballot Box">☐ Ballot Box</button></li>' +
                '</ul></div>';

            listDiv.innerHTML = list;
            return listDiv;
        },
        pickup: function (e: any) {
            if (!/^BUTTON$/i.test(e.target.tagName)) return false;

            e.preventDefault();
            e.stopPropagation();

            const command = e.target.getAttribute('data-command');

            // Create and insert the symbol at the current selection
            if (command === 'section') {
                const text = this.util.createTextNode("§");
                this.insertNode(text, null, true);
            } else if (command === 'trademark') {
                const text = this.util.createTextNode("™");
                this.insertNode(text, null, true);
            } else if (command === 'copyright') {
                const text = this.util.createTextNode("©");
                this.insertNode(text, null, true);
            } else if (command === 'provisionLabel') {
                const unicodeCharacter = String.fromCodePoint(0x1F3F7);
                const text = this.util.createTextNode(unicodeCharacter);
                this.insertNode(text, null, true);
            } else if (command === 'blankLeader') {
                const text = this.util.createTextNode("→");
                this.insertNode(text, null, true);
            } else if (command === 'blankLeaderV2') {
                const text = this.util.createTextNode("↦");
                this.insertNode(text, null, true);
            } else if (command === 'dotLeader') {
                const text = this.util.createTextNode("…");
                this.insertNode(text, null, true);
            } else if (command === 'ballotBox') {
                const text = this.util.createTextNode(String.fromCharCode(0x2610));
                this.insertNode(text, null, true);
            }


            // Add to history for undo functionality and close submenu
            this.history.push(false);
            this.submenuOff();
        }
    }
    return plugin;
}
